import React,{useRef,useEffect} from 'react'
import { GrFormSearch } from "react-icons/gr";
function ColumnSearch({setSearchColumn,setSearch,column,className}) {

    const searchRef=useRef(null)


    const handleDisplay= ()=>{
        if(searchRef.current.style.display==='none'){
            searchRef.current.style.display='block'
        }else{
            searchRef.current.style.display='none'
        }
    }

   
  return (
    <div className={className}>
        <GrFormSearch onClick={()=>{
            handleDisplay();
            setSearchColumn(column)
             }}   />      
         <div ref={searchRef} style={{
            position:'absolute',
            display:'none',
            marginLeft:'-160px',
            zIndex:22
         }} >
            <input onChange={(e)=>{
                setSearch(e.target.value)
            }} className='input-search' placeholder='Search' type='text' />
         </div>  
    </div>
  )
}

export default ColumnSearch
